export default "__VITE_ASSET__B4Mn$Op8__"